export const PublicRoutes = {
    LOGIN:'login',
    LOGINTEACHER: 'login'
}

export const SharedRoutes = {
    AYUDA: '/ayuda',
}

export const PrivateRoutes = {
    ROOT:'/',
    INICIO:'/inicio',
    SETTINGS: '/configuracion',

    ADMINISTRACION:'/administracion',
    PERIODO:'/periodo',
    HABILITARDOCENTE:'/habilitar-docente',
    HABILITARMATERIA:'/habilitar-materia',
    REPORTES:'/reportes',
    JUSTFICACIONES: '/justificaciones',
    
    HOMETEACHER: '/docente',
    REPORTETEACHER: '/docente/reporte',
    
    CONTROLPERMANENCIA: 'control-permanencia',
    CONTROLPERMANENCIATEST: 'control-permanencia-prueba',
}
